import { createSlotsContext } from "@grandvisionhq/slots";
const [PaymentDetailsFormSlotsProvider, usePaymentDetailsFormSlots] = createSlotsContext({
  displayName: "PaymentDetailsFormSlotsContext"
});
export {
  PaymentDetailsFormSlotsProvider,
  usePaymentDetailsFormSlots
};
//# sourceMappingURL=PaymentDetailsFormSlotsContext.js.map
